<template>
  <div class="content">


    <div class="w1200">
      <div class="mianbao over">
        <router-link to="/index" class="fl" style="padding-left: 20px;">首页</router-link>
        <el-image src="/static/imgs/yui.png" fit="cover" class="fl"
          style="width: 18px;height: 18px;padding-top: 2px;display: block;margin: 0 6px;" />

        <div @click="goQg" class="fl cupo">求购</div>
        <el-image src="/static/imgs/yui.png" fit="cover" class="fl"
          style="width: 18px;height: 18px;padding-top: 2px;display: block;margin: 0 6px;" />
        <div class="fl"> {{form.title}}</div>
      </div>
    </div>



    <div class="seekBox ">

      <div class="div-fl">
        <div class="div-fl-d1">

          <div style="  padding: 0 24px 24px 24px;">
            <div class="div-fl-d1-head dis">
              <div>
                <div class="div-fl-d1-head-tit">
                  {{form.title}}
                </div>
                <div class="div-fl-d1-head-txt">
                  发布日期：{{form.createDateString}}
                </div>
              </div>
              <div class="div-fl-d1-head-btn" @click="baojia(form.id)">
                我要报价
              </div>
            </div>
          </div>
        </div>

        <div class="div-fl-d2">
          <div class="div-fl-d2-head over">
            <div class="div-fl-d2-head-bar fl" />


            <div class="div-fl-d2-head-tit fl">
              求购信息
            </div>
          </div>


          <div class="div-fl-d2-list over">
            <div class="div-fl-d2-list-fl fl">
              求购分类：
            </div>
            <div class="div-fl-d1-list-fl fl">
              {{form.categoryName||''}}
            </div>
          </div>
          <div class="div-fl-d2-list over">
            <div class="div-fl-d2-list-fl fl">
              求购描述：
            </div>
            <div class="div-fl-d1-list-fl fl">
              {{form.title}}
            </div>
          </div>
          <div class="div-fl-d2-list over">
            <div class="div-fl-d2-list-fl fl">
              收货地：
            </div>
            <div class="div-fl-d1-list-fl fl">
              {{form.addressDisplay || '不限'}}
            </div>
          </div>
          <div class="div-fl-d2-list over">
            <div class="div-fl-d2-list-fl fl">
              数量：
            </div>
            <div class="div-fl-d1-list-fl fl">
              {{form.quantity || '不限'}} <span
                v-if="form.quantity&&form.unitName && form.quantity!='不限'">{{form.unitName}}</span>
            </div>
          </div>
          <div class="div-fl-d2-list over">
            <div class="div-fl-d2-list-fl fl">
              是否含税：
            </div>
            <div class="div-fl-d1-list-fl fl">
              {{form.taxRateType?'含税':'不含税'}}
            </div>
          </div>
          <div class="div-fl-d2-list over">
            <div class="div-fl-d2-list-fl fl">
              配送方式：
            </div>
            <div class="div-fl-d1-list-fl fl">
              {{form.shippingMethod?'物流配送':'自提'}}
            </div>
          </div>
          <div class="div-fl-d2-list over">
            <div class="div-fl-d2-list-fl fl">
              联系电话：
            </div>
            <div class="div-fl-d1-list-fl fl">
              <span class="dis cupo" style="width: 180px;">
                {{form.telePhone || ''}}
                <img src="../../../static/imgs/fsdh.png" style="width: 20px;height: 20px;" />
                <span style="color: #f46132;" class="cupo" @click="dialogVisible = true">点击联系</span>
              </span>
              <br />
              <span class="tishi">联系我时，请说是在聚木网上看到的</span>
            </div>
          </div>

          <div class="div-fl-d2-list over" v-if="form.remark">
            <div class="div-fl-d2-list-fl fl">
              详细要求：
            </div>
            <div class="div-fl-d1-list-fl fl">
              {{form.remark}}
            </div>
          </div>

          <div class="div-fl-d2-list over" v-if="form.imageUrlList  &&  form.imageUrlList.length !== 0">
            <div class="div-fl-d2-list-fl fl">
              图片：
            </div>
            <div class="div-fl-d1-list-fl fl over">

              <div class="fl" style="width:140px;height:140px;margin-right: 14px;position: relative;"
                v-for="(item,index) in form.imageUrlList" :key="index"
                v-if="form.imageUrlList   && form.imageUrlList.length !== 0">

                <img src="../../../static/imgs/plays.png" v-if="item.includes('.mp4') || item.includes('.MP4') "
                  class="sanjiao" @click="videoPlay(index)" />

                <video :ref="'myVideo'+index" v-if="item.includes('.mp4') || item.includes('.MP4') " width="100%"
                  height="100%" :autoplay="false" :src="$imgUrl + item "></video>
                <el-image v-else :src="$imgUrl + item" fit="cover" :preview-src-list="imgArr"
                  style="width: 100%;height: 100%;" />


              </div>
            </div>
          </div>

        </div>
        <div style="background: #F3F5F7;height: 24px;"></div>
        <div class="div-fl-d3" style="padding-top: 24px;border-radius: 12px">
          <div class="div-fl-d3-had over">
            <img src="/static/imgs/dun.png" class="fl" style="width: 20px;height: 20px;margin-right: 8px;" />
            <div class="wxts fl">
              温馨提示：
            </div>
          </div>
          <div class="div-fl-d3-list">
            1、此信息由注册用户自主发布，其真实性、准确性和合法性均由发布者承担
          </div>
          <div class="div-fl-d3-list">
            2、交易完成前，请勿轻易付款，谨防商业诈骗，避免经济损失
          </div>
          <div class="div-fl-d3-list">
            3、如您发现该信息有任何违法/侵权信息，请立即向平台举并提供有效线索
          </div>
          <div class="div-fl-d3-list">
            4、平台仅提供撮合交易服务，用户在平台获得信息私下成交的，由此产生的资金损失及货品质量等法律问题平台不予承担
          </div>
          <div class="div-fl-d3-list">
            5、平台提供免费的质检服务，用户通过平台交易可联系客服协助质检看货
          </div>

        </div>

      </div>

      <div class="div-fr">
        <div class="div-fr-head"></div>
        <div class="div-fr-cont">
          <div class="div-fr-cont-img" style="text-align: center;" v-if="conform">
            <img :src="conform.userHeadUrl ? $imgUrl + conform.userHeadUrl  : '/static/imgs/dimg.png'"
              style="width: 50px;height: 50px;display: block;border-radius: 100%;position: absolute;left: 115px;top: 65px;" />
            <div class="" style="font-size: 16px; color: #000;font-weight: bold;padding-top: 45px;">
              {{conform.userName}}
            </div>
            <img src="../../../static/imgs/yrz.png" v-if="conform.userAuthenticationFlag"
              style="width:54px;height: 20px;display: block;margin: 4px auto 10px  auto;" />

            <div class="div-fr-cont-txt">
              <div class="div-fr-cont-txt-p">
                <div class="div-fr-cont-txt-p-list over">
                  <div class="fl ww100">联系电话：</div>
                  <div class="fl kk100"> {{this.formatPhoneMi(conform.userPhone)}}</div>
                </div>
                <div class="div-fr-cont-txt-p-list over">
                  <div class="fl ww100"> 公司所在地：</div>
                  <div class="fl kk100"> {{conform.companyAddress ||'暂未设置'}}</div>
                </div>
                <div class="div-fr-cont-txt-p-list over">
                  <div class="fl ww100"> 经营品种：</div>
                  <div class="fl kk100"> {{conform.pz ||'暂未设置'}}</div>
                </div>
                <div class="div-fr-cont-txt-p-list over">
                  <div class="fl ww100"> 企业介绍：</div>
                  <div class="fl kk100 ">
                    {{conform.intro ||'这个人很懒什么都没留下'}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>



    <div class="bom-div" v-if="bomShow">
      <div class="div-bg">
        <div style="padding:72px 0 6px 0 ;"><canvas id="QRCode_header"></canvas></div>
      </div>
      <el-image src="/static/imgs/close.png" fit="cover" style="width: 60px;height: 60px;padding-top: 22px" class="cupo"
        @click="bomShow = false" />

    </div>

    <el-dialog title="感谢您的关注" :visible.sync="dialogVisible" width="30%">
      <span v-if="conform">联系电话：{{form.callPhone}}</span>
      <span slot="footer">
        <el-button type="primary" @click="dialogVisible = false" size="small">确 定</el-button>
      </span>
    </el-dialog>


  </div>
</template>

<script>
  export default {

    data() {
      return {
        dialogVisible: false,
        bomShow: false,
        form: {},
        imgArr: [],
        conform: {}
      }
    },
    watch: {
      '$route': {
        handler(newValue) {
          if (newValue.path.includes('/demand/seekarticle')) {
            this.seekgetArt(newValue.params);

          }
        },
        immediate: true
      }
    },
    methods: {

      goQg() {
this.$router.go(-1)

      },
      formatPhoneMi(phone) {
        if (!phone || phone.length !== 11) return ''
        return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
      },

      videoPlay(i) {
        this.$nextTick(() => {

          // 使用了v-for循环动态绑定ref，this.$ref[name]获取的是数组
          // 因此this.$refs[name]改为this.$refs[name][0]



          let video = this.$refs['myVideo' + i][0];
          if (video.requestFullscreen) {
            video.requestFullscreen().catch((err) => {
              console.error(err);
            });
          } else if (video.mozRequestFullScreen) {
            /* Firefox */
            video.mozRequestFullScreen().catch((err) => {
              console.error(err);
            });
          } else if (video.webkitRequestFullscreen) {
            /* Chrome, Safari & Opera */
            video.webkitRequestFullscreen().catch((err) => {
              console.error(err);
            });
          } else if (video.msRequestFullscreen) {
            /* IE/Edge */
            video.msRequestFullscreen().catch((err) => {
              console.error(err);
            });
          }

          video.play()



        });

      },

      baojia(id) {
        this.useqrcode('qgline', {
          id: id,
          link: 'index',
          channelType: '4'
        }, 200, 200)
        this.bomShow = true

      },
      seekgetArt(query) {
        this.$request('get', this.$wxapi + 'buyrequests/official-site/detail/' + query.id, {}, (res) => {
          if (res.status == 200) {
            this.form = res.data.data

            if (this.form.imageUrlList && this.form.imageUrlList.length !== 0) {

              let arr = []
              for (let i in this.form.imageUrlList) {
                if (this.form.imageUrlList[i].includes('.mp4') || this.form.imageUrlList[i].includes('.MP4')) {

                } else {
                  arr.push(this.$imgUrl + this.form.imageUrlList[i])
                }

              }

              this.imgArr = arr

            }

              this.$store.commit('isDetail', !this.$store.state.isDetail)

          } else {
            this.$toast('求购详情请求失败');
          }
        })
        delete query.id
        this.$request('get', this.$wxapi + 'member/official-site/index/info', query, (res) => {
          if (res.status == 200) {
            this.conform = res.data.data
          } else {
            this.$toast('店铺详情请求失败');
          }
        })
      }
    },
    metaInfo() {
      return {
        title: '聚木网-求购详情'
      }
    }
  }
</script>

<style scoped>
  @import url('../../../static/css/seekarticle.css');
</style>



// WEBPACK FOOTER //
// src/components/demand/seekarticle.vue